import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { IBadgeComponent } from "@front/m19-ui";
import { SBStrategyLineCreative } from "@m19-board/strategies/strategy-grid/strategy-grid.service";

@Component({
  selector: "app-strategy-grid-ad-line",
  template: `<div class="flex gap-2" *transloco="let t">
    @if (productCollectionAdLinesCount()) {
      <IBadge
        color="white"
        [label]="productCollectionAdLinesCount() + ' ' + t('creative-display.product_collection')"
      />
    }
    @if (manualCollectionAdLinesCount()) {
      <IBadge color="white" [label]="manualCollectionAdLinesCount() + ' ' + t('sb-form-ad-format.manual_collection')" />
    }
    @if (videoAdLinesCount()) {
      <IBadge color="white" [label]="videoAdLinesCount() + ' ' + t('sb-form-creative.video')" />
    }
    @if (storeSpotlightAdLinesCount()) {
      <IBadge color="white" [label]="storeSpotlightAdLinesCount() + ' ' + t('sb-form-ad-format.store_spotlight')" />
    }
    @if (brandVideoAdLinesCount()) {
      <IBadge color="white" [label]="brandVideoAdLinesCount() + ' ' + t('sb-form-ad-format.brand_video')" />
    }
  </div>`,
  imports: [IBadgeComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyGridAdLineComponent {
  strategyCreatives = input.required<SBStrategyLineCreative>();

  productCollectionAdLinesCount = computed(() => this.strategyCreatives().productCollection.length);
  manualCollectionAdLinesCount = computed(() => this.strategyCreatives().manualCollection.length);
  videoAdLinesCount = computed(() => this.strategyCreatives().video.length);
  storeSpotlightAdLinesCount = computed(() => this.strategyCreatives().storeSpotlight.length);
  brandVideoAdLinesCount = computed(() => this.strategyCreatives().brandVideo.length);
}
